// extracted by mini-css-extract-plugin
export default {"postColumn":"gear-view__postColumn__hgz9Q"};